import React from 'react';
import { Box, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import PrimaryActionButton from '../components/PrimaryActionButton';

function WelcomeStep({ mobile, mobileLength, propertyName = 'Nagendra PG', isLoadingUser = false, onMobileChange, onProceed }) {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 'calc(100vh - 80px)' }}>
      <SensorOccupiedIcon sx={{ fontSize: 160, color: 'primary.light', opacity: 0.28, mb: 5 }} />
      <Typography variant="h5" fontWeight={700} textAlign="center">
        Welcome to
      </Typography>
      <Typography variant="h4" fontWeight={800} textAlign="center" sx={{ color: 'primary.dark', mt: 2 }}>
        {propertyName}
      </Typography>
      <Typography variant="h6" textAlign="center" sx={{ maxWidth: 620, mt: 3, mb: 4, lineHeight: 1.45 }}>
        We need some details to check you into this property, let's create your profile to get started.
      </Typography>
      <Box sx={{ width: '100%', maxWidth: 620 }}>
        <TextField
          value={mobile}
          onChange={onMobileChange}
          label="Mobile Number"
          placeholder="Mobile Number"
          inputProps={{ maxLength: 10, inputMode: 'numeric' }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneAndroidIcon color="disabled" />
              </InputAdornment>
            ),
          }}
          fullWidth
        />
        <Typography variant="body2" textAlign="right" sx={{ mt: 1 }}>
          {mobileLength}/10
        </Typography>
      </Box>
      <PrimaryActionButton onClick={onProceed} sx={{ mt: 2 }} disabled={mobileLength !== 10 || isLoadingUser}>
        {isLoadingUser ? 'Please wait...' : 'Proceed'}
      </PrimaryActionButton>
    </Stack>
  );
}

export default WelcomeStep;
